import React from 'react';
import {RichText} from 'prismic-reactjs';
import Prismic from 'prismic-javascript';
import PrismicConfig from '../../prismic-configuration';

import HexaContainer from '../../Components/HexaContainer/HexaContainer';
import NotFound from '../../NotFound';
import styles from './Footer.scss';

export default class Footer extends React.Component{
    state = {
        doc: null,
        notFound: false,
    }
    
    componentWillMount() {
        Prismic.api(PrismicConfig.apiEndpoint).then(api => {
            api.query(
            Prismic.Predicates.at('document.type', 'footer'),
            { pageSize : this.state.showAmount }
            ).then(response => {
                if(response.results.length > 0){
                    this.setState({ doc: response.results });
                } else{
                    this.setState({ notFound: true });
                }
            });
        });
    }
    
    componentDidUpdate() {
    } 

    render(){
        if(this.state.doc){
            const {email, phone_number, social_media} = this.state.doc[0].data

            return(
                <footer className={styles.footer}>
                    <HexaContainer key={'general_footer'} elements={[
                        <React.Fragment key={'general_footer_info'}>
                            <ul className={styles.contact_info}>
                                {email && (
                                    email.map((item, index) => {
                                        return(
                                            <li key={'Email_'+index}>
                                                <a href={"mailto:" + item.text + "?subject=Contact via website ti-bor.nl&body=[Type message here]"}>{item.text}</a>
                                            </li>
                                        )
                                    })
                                )}
                                {phone_number && (
                                    phone_number.map((item, index) => {
                                        return(
                                            <li key={'Phone_number_'+index}>
                                                <a href={"tel:" + item.text}>{item.text}</a>
                                            </li>
                                        )
                                    })
                                )}
                            </ul>
                            <div className={styles.social_media}>
                                {social_media.map((item, index) => {
                                    const target = item.url.target
                                    return(
                                        <a key={'Social_Media_'+index} href={item.url.url} className={styles.social_icons} target={target} title={RichText.asText(item.name)} dangerouslySetInnerHTML={{__html: item.svg[0].text}}></a>
                                    )
                                })}
                            </div>
                        </React.Fragment>
                    ]} type={'header'} extraClass={styles.footer_hexa} />
                </footer>            
            );
        } else if (this.state.notFound) {
            return <NotFound />;
        }
        return <h1>Loading</h1>;
    }
}


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js